import { createApp } from 'vue';
import App from './App.vue';

//const routerPath = process.env.VUE_APP_ROUTER2 === 'Portal' ? './router/index.js' : './routerAdmin/index.js';
const routerPath = './router' ;
const loadRouter = async () => {
  try {
    if (process.env.VUE_APP_ROUTER2 === 'Portal'){
      const { default: router } = await import('./router/index.js');
      createApp(App)
        .use(router) // Asegúrate de que el router se esté utilizando aquí
        .mount('#app');
    } else {
      const { default: router } = await import('./routerAdmin/index.js');
      createApp(App)
        .use(router) // Asegúrate de que el router se esté utilizando aquí
        .mount('#app');
    }
  } catch (error) {
    console.error("Error loading router:", error);
    console.error("Router Path:", routerPath); // Muestra la ruta que se intenta importar
  }
};

loadRouter();